import { useRouter } from 'next/router';

import { useUserContext } from '@collab/features/user';
import { ComponentWithPageMods } from '@collab/layouts/PageLayout';
import { ModalCard } from '@collab/organisms';
import { getLoginRedirectUrl } from '@collab/utils/session';

const LoginHelp: ComponentWithPageMods<{
  websiteName: string;
  supportEmail: string;
  login: (redirectUrl: string) => Promise<void>;
  logout: () => Promise<void>;
}> = ({ websiteName, supportEmail, login, logout }) => {
  const router = useRouter();
  const { isUserStatusLoading } = useUserContext();

  const goToHome = async () => {
    const loginRedirectUrl = getLoginRedirectUrl();

    await logout();
    router.push(loginRedirectUrl ?? '/');
  };

  const goToLogin = async () => {
    const loginRedirectUrl = getLoginRedirectUrl();

    await logout();
    await login(loginRedirectUrl ?? '/');
  };

  return (
    <ModalCard title="Account recovery">
      <p className="text-secondary">
        Unable to access your {websiteName} account? Please contact our{' '}
        <a href={`mailto:${supportEmail}`}>support</a>.
      </p>
      <button
        className="button-filled mt-48"
        type="button"
        onClick={goToLogin}
        disabled={isUserStatusLoading}
      >
        Back to log in
      </button>
      <button
        className="button-outlined mt-16"
        type="button"
        onClick={goToHome}
      >
        Home
      </button>
    </ModalCard>
  );
};

LoginHelp.pageMods = { withLayout: false, seoNoIndex: true };

export default LoginHelp;
